module.exports = __webpack_public_path__ + "static/media/bnr_ritsu373aaa998e78e351ce81cf6860e536be.webp";